<template>
  <div class="widget-media-time-input">
    <b-input :disabled="disabled" :value="value" :placeholder="placeholder" class="widget_input"
      @dblclick.native="onClick" type="input" placeholder="Choose Movie Duration"></b-input>
    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" :width="800">
      <div style="height: 500px">
        <ClapprPlayer :src="`${src}`" :initial="value" @time-updated="onChange" :muted="true" type="hls"></ClapprPlayer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "widget-media-time-input",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show_player: false,
    };
  },
  watch: {},
  mounted() { },
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("input", e.current);
    },
    onClick(e) {
      let vm = this;
      vm.show_player = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";

.widget-media-time-input {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
